<template>
  <cg-edit-form v-if="Value" v-model="Value" :colInfo="CfgDescCfgColInfo" />
</template>

<script>
import Vue from "vue";

export default {
  name: "CgCfgDescCfgForm",
  props: {
    value: {
      type: Object,
      required: true,
    },
    controlType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    Value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    CfgDescCfg() {

      let _controlCfg = CmnMis.Func.GetControlCfg(this.controlType);

      return _controlCfg ? _controlCfg.CfgDescCfg : null;
    },
    CfgDescCfgColInfo() {
      const _cfgDescCfg = this.CfgDescCfg;
      if (!_cfgDescCfg) {
        return [];
      }

      const _colInfo = [];

      Object.keys(_cfgDescCfg)
        .filter((item) => _cfgDescCfg[item]?.ControlCfg?.IsHidden !== "1")
        .forEach((key) => {
          const _item = _cfgDescCfg[key];

          _colInfo.push({
            ColName: key,
            ColControlName: _item.ControlName,
            ColTitle: _item.ControlCfg?.Desc || "",
            IsShowInEdit: "1",
            ControlCfg: Object.assign({}, _item.ControlCfg || {}, {
              ColTitle: _item.ControlCfg?.Desc || "",
              // Default: _item?.Cfg?.DefaultValue || new (_item?.Cfg?.Type || String)().valueOf()
              Default: _item?.Cfg?.DefaultValue || "",
            }),
          });
        });
      return _colInfo;
    },
  },
  watch: {
    value: {
      handler() {
        const _cfgDescCfg = this.CfgDescCfg;
        Object.keys(this.value || {}).forEach((key) => {
          if (!Reflect.has(_cfgDescCfg || {}, key)) {
            Reflect.deleteProperty(this.value, key);
          }
        });
        Object.keys(_cfgDescCfg || {}).forEach((key) => {
          const _item = _cfgDescCfg[key];
          const _cfg = _item.Cfg || {};
          if (!Reflect.has(this.value, key)) {
            // this.$set(this.value, key, new (_cfg.Type || String)(_cfg.DefaultValue || "").valueOf());
            this.$set(this.value, key, _cfg.DefaultValue || "");
          }
        });
      },
      immediate: true,
    },
  },
};
</script>
